import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from '../../../../../core/ccomx-date-formats';
import {
  PermitState,
  PermitUrgency,
} from '../../../../../permit-to-work-user/permit-to-work-api.service';

@Component({
  selector: 'app-permit-to-work-template',
  templateUrl: './permit-to-work-template.component.html',
  styleUrls: ['./permit-to-work-template.component.scss'],
  standalone: false,
})
export class PermitToWorkTemplateComponent {
  @Input() element: any;
  @Input() columnName: string;
  readonly dateFormat = DEFAULT_DATE_TIME_FORMAT;
  readonly states = PermitState;
  readonly urgencyLabels: Record<number, string> = {
    [PermitUrgency.Normal]: 'ok',
    [PermitUrgency.DueSoon]: 'expiring',
    [PermitUrgency.Overdue]: 'expired',
  };
  get approverNames(): string {
    return [
      ...new Set([
        ...(this.element.approverUserNames ?? []),
        ...(this.element.approverPositionNames ?? []),
        ...(this.element.approverPositionGroupNames ?? []),
        ...(this.element.approverRoleNames ?? []),
      ]),
    ].join(', ');
  }
  get linkedFormNames(): string {
    return [
      ...new Set(
        [...(this.element.defaultPreApprovalForms ?? []), ...(this.element.defaultForms ?? [])].map(
          (form: { name: string }) => form.name
        )
      ),
    ].join(', ');
  }
}
